import { resolveComponent } from '../factory/resolve';

export default resolveComponent('ClosableBanner');
